import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-20 px-6 relative overflow-hidden bg-[#161616]" data-id="element-100">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-brand-rose/10 pointer-events-none" data-id="element-101" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-102">
        <FadeIn data-id="element-103">
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-8 text-brand-cream" data-id="element-104">
            No dejes que el silencio <br className="hidden md:block" data-id="element-105" />
            <span className="text-brand-rose italic" data-id="element-106">gane esta vez.</span>
          </h2>

          <a href="https://oliverpublicista-2.myshopify.com/cart/43150580056154:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center gap-2 px-8 py-5 bg-brand-rose text-white text-lg md:text-xl font-bold rounded-full overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_40px_rgba(225,29,72,0.4)] active:scale-95 w-full md:w-auto" data-id="element-107">
            <span className="relative z-10" data-id="element-108">
              👉 QUIERO QUE ME VUELVA A RESPONDER
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-109" />
          </a>
        </FadeIn>
      </div>
    </section>;
}